import Vue from 'vue'
import axios from 'axios';
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import vuetify from './plugins/vuetify';
import Affix from 'vue-affix';
import vClickOutside from 'v-click-outside';
import moment from 'moment';
import VueTheMask from 'vue-the-mask'
import 'moment/locale/nb';
moment.locale('nb');
Vue.use(Affix);
Vue.use(vClickOutside);
Vue.use(VueTheMask);

Vue.config.productionTip = false;

Vue.prototype.$http = axios.create({
  baseURL: '/api/'
});

new Vue({
    router,
    vuetify,
    render: h => h(App),
    data: {
        messages: [],
        user: null,
        settings: {},
        printer: null
    },

    created() {
        this.$http.interceptors.response.use(null, (error) => {
            if (error.response.status === 401) {
                this.$router.push({name: 'Login'});
            } else if (error.response.status === 403) {
                let message = error.response.data.message;
                if (message) this.addMessage(message, 'red');
            } else if (error.response.status === 422) {
                let messages = Object.values(error.response.data.errors).map(it => it[0]);
                this.addMessage(messages.join('\n'), 'red');
            }
            return Promise.reject(error);
        });

        setInterval(() => {
            this.messages = this.messages.filter(message => message.visible);
        }, 1000);

        this.loadLabelPrinter();
        setInterval(() => {
            console.log('Loading printer info...');
            this.loadLabelPrinter();
        }, 15 * 60 * 1000); // 15 minutes.
    },

    methods: {
        addMessage(message, type = 'info') {
            this.messages.push({
                key: Math.random().toString(36).substr(2, 5),
                message: message,
                visible: true,
                type: type
            });
        },
        loadLabelPrinter() {
            axios('https://localhost:9101/available').then(response => {
                let printer = response.data.printer[0];

                // Read status
                axios.post('https://localhost:9101/write', {
                    device: printer,
                    data: '~HQES'
                }).then(response => {
                    axios.post('https://localhost:9101/read', {device: printer}).then(response => {
                        this.$root.printer = {
                            device: printer,
                            status: response.data
                        }
                    }).catch(() => this.$root.printer = null);
                }).catch(() => this.$root.printer = null);
            }).catch(() => this.$root.printer = null);
        }
    }
}).$mount('#app');
